import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';
import {CommonButton} from './CommonButton';
import CommonTheme from '../../../Theme';

/** ポジティブボタンで使用するパレット */
const palette = CommonTheme.palette.primary;

const styles = (theme) => createStyles({
  root: {
    color: palette.contrastText,
    background: palette.main,
    borderColor: palette.main,
  },
});
const styles2 = (theme) => createStyles({
  root: {
    color: palette.dark, // '#4F89C6',
    background: '#fff',
    borderColor: '#C0C0C0',
  },
});
const standardStyles = (theme) => createStyles({
  root: {
    color: '#000000',
    backgroundColor: '#FFFFFF',
    borderColor: '#C0C0C0',
  },
});

/** ポジティブボタンスタイル */
export const PositiveButton = withStyles(styles)(CommonButton);
export const PositiveButton2 = withStyles(styles2)(CommonButton);
export const StandardButton = withStyles(standardStyles)(CommonButton);
